import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import { userOption, userResult } from '../../models/orders/order-list-model';
import { Dropdown, DropdownChangeEvent, DropdownFilterEvent } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import orderServices from '../../services/orders/orderservice';
import '../../assests/css/common/responsive-ui.css';

interface SearchPanelProps {
  onSearch: (query: string) => void;
  setLoading: (loading: boolean) => void;
}

const ReferralsSearch: React.FC<SearchPanelProps> = ({ onSearch, setLoading }) => {

  const [selectedUser, setSelectedUser] = useState<any>();
  const blankUserDetail: userOption[] = [{ userID: 0, name: '', primaryContactNbr: '' }];
  const [orderUsers, setOrderUsers] = useState<userOption[]>(blankUserDetail);
  const [orderUser, setOrderUser] = useState<userResult[]>([]);
  const [keyword, setKeyword] = useState<string>('');

  useEffect(() => {
    setOrderUser(orderUsers.map((user) => ({
      userID: user.userID,
      detail: `${user.name}, ${user.primaryContactNbr}`,
    })));
  }, [orderUsers]);

  const handleDropdownChange = (e: DropdownChangeEvent) => {
    setSelectedUser(e.value);
  }

  const handleDropdownFilter = (e: DropdownFilterEvent) => {
    if (e.filter.length > 2) {
      orderServices.getOrderUsers(e.filter).then((response: userOption[]) => {
        if (response.length > 0) {
          setOrderUsers(response)
        }
      })
    }
  }

  const handleSearch = () => {
    setLoading(true);
    let searchFilter: string = "?$filter=true";
    if (selectedUser) {
      searchFilter = searchFilter + " and userID eq " + selectedUser;
    }
    if (keyword) {
      searchFilter = searchFilter + " and (startswith(name, '" + keyword + "') or startswith(primaryContactNbr, '" + keyword + "'))";
    }
    onSearch(searchFilter);
  }

  const resetSearchFields = () => {
    setOrderUsers(blankUserDetail);
    setSelectedUser(null);
    setKeyword('');
    onSearch('?$filter=false'); // Returns empty
  }

  return (
    <>
      <style>{`
          .users-search-container {
              border: 1px solid rgba(76, 175, 80, 0.15);
              background: #ffffff;
              border-radius: 12px;
          }
          .users-search-container .search-panel-header {
              display: flex;
              align-items: center;
              gap: 0.5rem;
              margin-bottom: 1rem;
              padding-bottom: 0.75rem;
              border-bottom: 1px solid #f0f0f0;
          }
          .users-search-container .search-panel-header i {
              color: #4CAF50;
              font-size: 1rem;
          }
          .users-search-container .search-panel-header span {
              font-weight: 600;
              color: #374151;
              font-size: 0.9rem;
          }
          .users-search-container .p-dropdown,
          .users-search-container .p-inputtext,
          .users-search-container .p-calendar {
              height: 40px !important;
              min-height: 40px !important;
              font-size: 0.9rem !important;
              border-radius: 8px !important;
              border-color: #e0e0e0 !important;
              width: 100% !important;
          }
          .users-search-container .p-button {
              height: 40px !important;
              border-radius: 8px !important;
          }
      `}</style>
      <div className="users-search-container surface-card p-3 shadow-2 mt-3 mb-4">
        <div className="search-panel-header">
          <i className="pi pi-filter-fill"></i>
          <span>Search Customers</span>
        </div>
        <div className="grid">
       
          <div className="col-12 sm:col-5 md:col-4">
            <Dropdown
              id="SearchUser"
              name="SearchUser"
              options={orderUser}
              optionLabel="detail"
              optionValue="userID"
              value={selectedUser}
              onChange={handleDropdownChange}
              onFilter={handleDropdownFilter} filter
              placeholder="Search for User/Mobile"
            />
          </div>
          <div className="col-6 sm:col-2 md:col-3 flex gap-2 justify-content-end align-items-center">
            <Button onClick={handleSearch} severity="success" style={{ minWidth: '100px' }}>Filter</Button>
            <Button onClick={resetSearchFields} severity="secondary" outlined style={{ minWidth: '100px' }}>Reset</Button>
          </div>
        </div>
      </div>
    </>
  );
};
export default ReferralsSearch;
